import {Controller} from "@hotwired/stimulus"

// Почему-то при нажатии Enter в поле с типом date не происходит автоматическая отправка формы.
// Возможно, это актуально ещё и для других типов полей. Для текста всё работает ожидаемо:
// по нажатию Enter в поле ввода форма отправляется. Этот контроллер позволяет эмулировать нужное
// поведение в других полях. Для этого нужно просто добавить его к нужному полю ввода.
export default class extends Controller {
  submit() {
    const form = this.element.form

    if (form.reportValidity()) {
      form.requestSubmit()
      this.element.parentNode.innerHTML = `<div class="m-auto">
      <div class="h-6 w-6 rounded-full border-4 border-t-4 border-gray-50 border-t-orange-700 animate-spin"></div>
    </div>`
    } else {
      form.reportValidity()
    }
  }

  submitNoLoaderInput() {
    const form = this.element.form

    if (form.reportValidity()) {
      form.requestSubmit()
    } else {
      form.reportValidity()
    }
  }
}
